import React, { useRef, useState } from 'react';
import { Card, Link, Grid, Typography } from '@material-ui/core';

import { JobSummary } from '../../../../components/JobSummary';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';
import { UploadButton } from '../../../../components/UploadButtonComponent';

import { GQLJobSummary, GQLPieceModel } from '@jewelutions/core-crm-server-api-client-domain';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { SvgDisplay } from '../../../../components';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';
import { Box } from '../../../../types-hack';
interface IProps {
  pieceId: string;
  model: GQLPieceModel;
}

const ModelDetailsCad: React.FC<IProps> = ({ pieceId, model }) => {
  const [cadFile, setCadFile] = useState(null as any);
  const cadJobImportStatus = useRef(null);

  const [
    uploadCad,
    { error: errorUploadingCadFile, loading: uploadingCadFile }
  ] = GQLOperationBuilder.piece.importPieceModelCadFile({
    onCompleted: () => {
      const curr = cadJobImportStatus?.current as any;
      curr?.refetchJobs();
    }
  });

  const { data: cadImportJobSummaryData } = GQLOperationBuilder.piece.importPieceModelCadFileJobs({
    pieceId: pieceId,
    pieceModelId: model.id
  });

  return (
    <Card style={{ marginBottom: '8px' }}>
      <Box p={5}>
        <Grid container direction="row">
          <Grid item xs={3}>
            <Grid container direction="column">
              <Typography variant={'h6'}>Piece Model CAD</Typography>
              <PublishableStatusComponent
                status={model.hasCadFileValid}
                text="Piece model CAD validity"
              ></PublishableStatusComponent>
              <span>Last model CAD import job status: </span>
              <JobSummary
                ref={cadJobImportStatus}
                jobSummary={
                  GQLOperationBuilder.piece.jobSummaryArrayFromResponse(cadImportJobSummaryData).length > 0
                    ? GQLOperationBuilder.piece.jobSummaryArrayFromResponse(cadImportJobSummaryData)[0]
                    : ((undefined as unknown) as GQLJobSummary)
                }
              />
              <UploadButton
                id={`modelDetailsImportNewCAD1_${pieceId}_${model.id}`}
                importButtonLabel={'Import new CAD'}
                fileTypesAsCsv={'.3dm'}
                onFileSelected={(file: File) => {
                  setCadFile(file);
                  uploadCad({
                    variables: {
                      pieceId: pieceId,
                      pieceModelId: model.id,
                      file
                    }
                  }).then(_result => {
                    successNotification(toast, 'CAD import job scheduled succesfully.', () => {});
                    window.location.reload();
                  });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        {model.editableSides.map(editableSide => {
          const mainEditableArea = model.editableAreas.find(ea => ea.side === editableSide.side);
          return (
            <Grid item xs={9}>
              <Grid container direction="row" wrap="nowrap">
                <Grid item direction={'column'} container alignItems="center" justify="center">
                  <Grid item>
                    <PublishableStatusComponent
                      status={model.hasIconValid}
                      text={`Piece model icon ${editableSide.side}`}
                    ></PublishableStatusComponent>
                  </Grid>
                  <Grid item>
                    {model.hasIconValid && (
                      <SvgDisplay style={{ width: `128px`, height: `128px` }} url={model.icon.url!} />
                    )}
                    {!model.hasIconValid && (
                      <img style={{ color: 'red' }} height={80} src={'/images/x-mark-128.png'}></img>
                    )}
                    {model.icon.url && <Link href={model.icon.url!}>Download</Link>}
                  </Grid>
                </Grid>

                <Grid item direction={'column'} container alignItems="center" justify="center">
                  <Grid item>
                    <PublishableStatusComponent
                      status={model.hasOutlineValid}
                      text={`Piece model outline ${editableSide.side}`}
                    ></PublishableStatusComponent>
                  </Grid>
                  <Grid item>
                    {model.hasOutlineValid && (
                      <SvgDisplay
                        style={{ width: `128px`, height: `128px` }}
                        url={
                          editableSide.shape.polyShape?.mediaDefined?.url
                            ? editableSide.shape.polyShape?.mediaDefined?.url
                            : ''
                        }
                      />
                    )}

                    {!model.hasOutlineValid && (
                      <img style={{ color: 'red' }} height={128} src={'/images/x-mark-128.png'}></img>
                    )}
                    {editableSide.shape.polyShape && (
                      <Link href={editableSide.shape.polyShape!.mediaDefined!.url!}>Download</Link>
                    )}
                  </Grid>
                </Grid>
                <Grid item direction={'column'} container alignItems="center" justify="center">
                  <Grid item>
                    <PublishableStatusComponent
                      status={model.hasEditableAreasValid}
                      text={`Piece model main engravable area ${editableSide.side}`}
                    ></PublishableStatusComponent>
                  </Grid>
                  <Grid item>
                    {model.hasEditableAreasValid && (
                      <SvgDisplay
                        style={{ width: `128px`, height: `128px` }}
                        url={
                          mainEditableArea?.shape?.polyShape?.mediaDefined?.url
                            ? mainEditableArea?.shape?.polyShape?.mediaDefined?.url
                            : ''
                        }
                      />
                    )}

                    {!model.hasEditableAreasValid && (
                      <img style={{ color: 'red' }} height={80} src={'/images/x-mark-128.png'}></img>
                    )}
                    {mainEditableArea && (
                      <Link href={mainEditableArea!.shape.polyShape!.mediaDefined!.url!}>Download</Link>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Box>
    </Card>
  );
};

export default ModelDetailsCad;
